import { FamilyService } from '@modules/family/family-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';

export default {
    namespaced: true,

    state: {
        findLoading: false,
        saveLoading: false,
        record: null,
    },

    getters: {
        record: (state) => state.record,
        findLoading: (state) => !!state.findLoading,
        saveLoading: (state) => !!state.saveLoading,
    },

    mutations: {
        RESET(state) {
            state.findLoading = false;
            state.saveLoading = false;
            state.record = null;
        },

        FIND_STARTED(state) {
            state.record = null;
            state.findLoading = true;
        },

        FIND_SUCCESS(state, payload) {
            state.record = payload;
            state.findLoading = false;
        },

        FIND_ERROR(state) {
            state.record = null;
            state.findLoading = false;
        },

        CREATE_STARTED(state) {
            state.saveLoading = true;
        },

        CREATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        CREATE_ERROR(state) {
            state.saveLoading = false;
        },

        UPDATE_STARTED(state) {
            state.saveLoading = true;
        },

        UPDATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        UPDATE_ERROR(state) {
            state.saveLoading = false;
        },
    },

    actions: {
        doNew({ commit }) {
            commit('RESET');
        },

        async doFind({ commit }, { id, subpropertyId }) {
            try {
                commit('FIND_STARTED');

                const record = await FamilyService.find(id, subpropertyId);

                commit('FIND_SUCCESS', record);
            } catch (error) {
                Errors.handle(error);
                commit('FIND_ERROR');
                routerAsync().push('/family');
            }
        },

        async doCreate({ commit }, { values, subpropertyId }) {
            try {
                commit('CREATE_STARTED');
                await FamilyService.create(values, subpropertyId);
                commit('CREATE_SUCCESS');
                Message.success(i18n('entities.family.create.success'));
                routerAsync().push('/family');
            } catch (error) {
                Errors.handle(error);
                commit('CREATE_ERROR');
            }
        },

        async doUpdate({ commit }, { id, values, subpropertyId }) {
            try {
                commit('UPDATE_STARTED');

                await FamilyService.update(id, values, subpropertyId);

                commit('UPDATE_SUCCESS');
                Message.success(i18n('entities.family.update.success'));
                routerAsync().push('/family');
            } catch (error) {
                Errors.handle(error);
                commit('UPDATE_ERROR');
            }
        },
    },
};